import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const field: CSSObject = {
  border: `1px solid ${color.grey100}`,
  borderRadius: 10,
  background: color.white,
  color: color.text,
  boxSizing: 'border-box',
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  ':hover:not(:disabled):not(:read-only)': {
    borderColor: color.grey200,
  },
  ':focus': {
    outline: 'none',
    borderColor: color.primary,
    boxShadow: `0 0 0 3px ${color.grey75}`,
  },
  '::placeholder': {
    color: color.grey300,
    fontSize: '14px',
    fontWeight: '400',
  },
  ':disabled': {
    background: color.grey50,
    color: color.grey400,
  },
};

const wrap: CSSObject = {
  ...field,
  padding: '0 12px',
  fontSize: '14px',
  height: '40px',
  maxWidth: '100%',

  ':read-only': {
    background: color.grey50,
    color: color.grey,
  },
};

const autoWrap: CSSObject = {
  '.react-autosuggest__container': {
    position: 'relative',
  },
  '.react-autosuggest__suggestions-container--open': {
    display: 'block',
    position: 'absolute',
    top: '44px',
    left: 0,
    right: 0,
    padding: '6px',
    border: `1px solid ${color.grey100}`,
    backgroundColor: color.white,
    borderRadius: radius.md,
    zIndex: 2,
    maxHeight: '200px',
    overflow: 'auto',
    boxShadow: theme.shadow.popover,
  },
  '.react-autosuggest__suggestion--highlighted': {
    background: color.grey75,
  },
  '.react-autosuggest__suggestion': {
    padding: '10px 10px',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: radius.sm,
    fontSize: 14,
    cursor: 'pointer',
  },
};

export { field, wrap, autoWrap };
